var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMymahi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 18,
    viewBox: "0 0 36 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6205 1.35114L17.5046 5.0592L27.8134 16.6894C28.4676 17.4283 29.3845 17.8825 30.3686 17.9552C31.3528 18.028 32.3265 17.7136 33.0822 17.0789L34.2396 16.1051C35.0081 15.4594 35.4888 14.535 35.5761 13.535C35.6634 12.5351 35.3501 11.5413 34.7052 10.7722C34.6841 10.7534 34.6659 10.7316 34.6512 10.7074L29.3169 4.64944L26.3534 1.28559C25.6895 0.533015 24.7545 0.0740472 23.7531 0.00911755C22.7516 -0.0558121 21.7652 0.278583 21.0097 0.939134C20.8801 1.06873 20.7393 1.20956 20.6205 1.35114Z",
    fill: "url(#paint0_linear_1614_4084)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.476 1.44744L17.5031 5.07122L7.86594 16.5699C7.22338 17.3387 6.30176 17.8206 5.30384 17.9098C4.30591 17.999 3.31342 17.6882 2.5447 17.0456L2.53346 17.0363L1.354 16.0508C0.585527 15.4081 0.103847 14.4864 0.0149212 13.4886C-0.074005 12.4907 0.237106 11.4984 0.879815 10.7299L0.889179 10.7187L8.6776 1.43657C9.32364 0.668413 10.2482 0.188134 11.2481 0.101259C12.2481 0.0143831 13.2416 0.328018 14.0105 0.973253C14.1789 1.11828 14.3347 1.27742 14.476 1.44893V1.44744Z",
    fill: "url(#paint1_linear_1614_4084)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3648 1.28522L29.6747 5.04984L20.5132 16.116C19.873 16.89 18.9518 17.3782 17.9519 17.4735C16.952 17.5688 15.9552 17.2634 15.1803 16.6242C14.9652 16.4506 14.7727 16.2508 14.6073 16.0294L11.5779 12.1348L20.6207 1.35077C21.2665 0.582398 22.1908 0.101749 23.1907 0.0143857C24.1906 -0.0729772 25.1843 0.240089 25.9535 0.884828C26.1013 1.00693 26.2391 1.1407 26.3655 1.28485L26.3648 1.28522Z",
    fill: "url(#paint2_linear_1614_4084)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.199,
    d: "M17.5054 5.0603L12.5396 13.3675L11.5767 12.1348L17.5054 5.0603ZM29.6754 5.04944L24.8283 13.3248L23.7897 12.1565L29.6754 5.04944Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1614_4084",
    x1: 20.5179,
    y1: 1.35741,
    x2: 33.3464,
    y2: 16.8559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA39F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1614_4084",
    x1: 14.6727,
    y1: 1.41799,
    x2: 1.75632,
    y2: 16.2674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1614_4084",
    x1: 14.699,
    y1: 15.748,
    x2: 26.1731,
    y2: 1.11057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMymahi);
export default __webpack_public_path__ + "static/media/mymahi.6d1e6b8a2e917f7ac52a21b84cc4fbf7.svg";
export { ForwardRef as ReactComponent };